import * as React from "react";
const SvgIcSend = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.833 18.333 20 10 .833 1.667v6.481L14.523 10 .834 11.852v6.481Z" /></svg>;
export default SvgIcSend;